import React from 'react';
export const CATS = {
  release:   { label: 'Release',   bg: '#dbeafe', fg: '#1e40af', emoji: '🚀' },
  tip:       { label: 'Tip',       bg: '#fef3c7', fg: '#92400e', emoji: '💡' },
  nieuws:    { label: 'Nieuws',    bg: '#d1fae5', fg: '#065f46', emoji: '📣' },
  onderhoud: { label: 'Onderhoud', bg: '#fee2e2', fg: '#991b1b', emoji: '🔧' },
};
export const fmt = (d) => new Date(d).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
export const Cat = ({ c }) => { const k = CATS[c] || CATS.nieuws; return <span style={{ background: k.bg, color: k.fg, fontSize: 11, fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase', padding: '4px 10px', borderRadius: 20 }}>{k.label}</span>; };
export const Bron = ({ n }) => n.bedrijf_id
  ? <span style={{ background: '#111827', color: '#fff', fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 6, textTransform: 'uppercase' }}>{n.bedrijf_naam}</span>
  : <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#6b7280' }}><span style={{ width: 18, height: 18, borderRadius: '50%', background: '#0f172a', color: '#fff', fontSize: 10, fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>W</span>WOMsys</span>;
export const Thumb = ({ n, height = 130, fontSize = 46 }) => n.afbeelding_url
  ? <div style={{ height, background: `url(${n.afbeelding_url}) center/cover` }} />
  : <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize, background: `linear-gradient(135deg, ${(CATS[n.categorie] || CATS.nieuws).bg}, #fff)` }}>{(CATS[n.categorie] || CATS.nieuws).emoji}</div>;

// Mini-markdown: ## kop, - lijst, **vet**, *cursief*, [tekst](url), lege regel = alinea
export function Markdown({ tekst }) {
  if (!tekst) return null;
  const inline = (t) => t.split(/(\*\*[^*]+\*\*|\*[^*]+\*|\[[^\]]+\]\([^)]+\))/g).map((s, i) => {
    let m;
    if ((m = s.match(/^\*\*(.+)\*\*$/))) return <strong key={i}>{m[1]}</strong>;
    if ((m = s.match(/^\*(.+)\*$/))) return <em key={i}>{m[1]}</em>;
    if ((m = s.match(/^\[([^\]]+)\]\(([^)]+)\)$/))) return <a key={i} href={m[2]} target="_blank" rel="noreferrer" style={{ color: '#2563eb' }}>{m[1]}</a>;
    return s;
  });
  const out = []; let lijst = [];
  const flush = () => { if (lijst.length) { out.push(<ul key={'ul' + out.length} style={{ margin: '8px 0 12px', paddingLeft: 22 }}>{lijst}</ul>); lijst = []; } };
  tekst.split('\n').forEach((line, i) => {
    if (/^\s*[-*] /.test(line)) { lijst.push(<li key={i} style={{ marginBottom: 4 }}>{inline(line.replace(/^\s*[-*] /, ''))}</li>); return; }
    flush();
    if (/^## /.test(line)) out.push(<h3 key={i} style={{ margin: '20px 0 8px', fontSize: 18 }}>{inline(line.slice(3))}</h3>);
    else if (line.trim()) out.push(<p key={i} style={{ margin: '0 0 12px', lineHeight: 1.65 }}>{inline(line)}</p>);
  });
  flush();
  return <div style={{ fontSize: 15, color: '#1f2937' }}>{out}</div>;
}
